import Vue from "vue"
// 信息脱敏
//去标识化 firstNum:从第几位开始有*，endNum有几个*
function hidden(str, firstNum = 1, endNum = 1,bool) {
	if (!str) {
		return ''
	}
	if (str.length == 1&&bool) {
		return '*'
	}
	let Star = ''
	for (let a = 0; a < endNum; a++) {
		Star += '*'
	}
	if(bool){
		return str.substr(0, firstNum) + Star + str.substr(endNum + firstNum, str.length)
	}else{
		return str
	}
}

export default {
	hidden
}



// WEBPACK FOOTER //
// ./static/js/function/deidentification.js